import api from './api';

export interface AcquisitionFilter {
  trafficContentId?: string;
  startAt?: string;
  endAt?: string;
}
export interface AcquisitionChannel {
  trafficContentId: string;
  boundUsers: string;
}
export interface AcquisitionBinding {
  userId: string;
  trafficContentId: string;
  boundAt: string;
}
export interface AcquisitionSummary {
  items: AcquisitionChannel[];
  totalBoundUsers: string;
  nextPageToken: string;
  snapshotAt: string;
}
export interface AcquisitionBindings {
  items: AcquisitionBinding[];
  nextPageToken: string;
  snapshotAt: string;
}
export interface AcquisitionUser {
  bound: boolean;
  binding?: AcquisitionBinding | null;
}
export interface AcquisitionApi {
  summary(
    filter: AcquisitionFilter,
    pageToken?: string,
  ): Promise<AcquisitionSummary>;
  bindings(
    filter: AcquisitionFilter,
    pageToken?: string,
  ): Promise<AcquisitionBindings>;
  user(userId: string): Promise<AcquisitionUser>;
}
const base = '/api/v1/admin/acquisition-attributions';
export const acquisitionApi: AcquisitionApi = {
  summary: (filter, pageToken) =>
    api.get<never, AcquisitionSummary>(`${base}/summary`, {
      params: { ...filter, pageSize: 50, pageToken },
    }),
  bindings: (filter, pageToken) =>
    api.get<never, AcquisitionBindings>(`${base}/bindings`, {
      params: { ...filter, pageSize: 50, pageToken },
    }),
  user: (id) =>
    api.get<never, AcquisitionUser>(`${base}/users/${encodeURIComponent(id)}`),
};
